import { render, staticRenderFns } from "./signDistrubution.vue?vue&type=template&id=47615b6d"
import script from "./signDistrubution.vue?vue&type=script&lang=js"
export * from "./signDistrubution.vue?vue&type=script&lang=js"
import style0 from "./signDistrubution.vue?vue&type=style&index=0&id=47615b6d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports